import { QueryOptionsType, Product } from '@framework/types'
import { useInfiniteQuery } from 'react-query'
import * as typesense from '../../../framework/basic-rest/typesense'
import { useRouter } from 'next/router'

type PaginatedProduct = {
  data: Product[]
  paginatorInfo: any
}
const fetchProducts = async ({ queryKey }: any) => {
  const [_key, _params, locale] = queryKey
  const category = _params.category
  const hits: any = _params.category
    ? (
        await typesense.getProductsByCategoryName({
          name: category,
          level: Number(_params.level || 1),
          locale: _params.locale,
          page: _params.page || 1,
          sort: _params.sort,
          filter: _params.filter,
        })
      ).hits
    : (await typesense.getFeaturedProducts(locale)).hits
  const products: Product[] = []
  hits.map((h: any) => {
    if (h.document.name) {
      products.push(h.document)
    }
  })

  return {
    data: products as Product[],
    paginatorInfo: {
      nextPageUrl: '',
    },
  }
}

const useProductsQuery = (options: QueryOptionsType) => {
  return useInfiniteQuery<PaginatedProduct, Error>(
    ['getCatProducts', options, useRouter().locale],
    fetchProducts,
    {
      getNextPageParam: ({ paginatorInfo }) => paginatorInfo.nextPageUrl,
    },
  )
}

export { useProductsQuery, fetchProducts }
